import * as React from 'react';
import { ChevronDown } from '@wix/wix-ui-icons-common/on-stage';
import { TextButton, TextButtonPriority } from '../TextButton';
import { DATA_HOOKS } from './constants';
import { st, classes } from './FloatingDropdownBase.st.css';
import classnames from 'classnames';
export class FloatingDropdownBase extends React.Component {
    constructor() {
        super(...arguments);
        this._getSelectedOption = (selectedId) => {
            const { options } = this.props;
            return options.find(({ id }) => selectedId === id);
        };
        this._onSelect = (e) => {
            const { onChange } = this.props;
            const selectedId = e.target.value;
            if (onChange) {
                onChange(selectedId);
            }
        };
    }
    _getContent() {
        const { value, placeholder, label, options, 'aria-labelledby': ariaLabelledBy, mobile, disabled, name, } = this.props;
        const selectedOption = this._getSelectedOption(value);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.content },
                React.createElement("div", { className: classes.textContent },
                    React.createElement("span", { className: classes.label }, label),
                    React.createElement("div", { className: classes.selectedValue, "data-hook": DATA_HOOKS.baseSelectedValue }, selectedOption?.value || placeholder)),
                React.createElement(ChevronDown, { "aria-hidden": true, className: classes.arrowIcon })),
            mobile ? (React.createElement("select", { value: value, name: name, className: classes.select, "aria-labelledby": ariaLabelledBy, "data-hook": DATA_HOOKS.nativeSelect, onChange: this._onSelect, disabled: disabled },
                placeholder ? (React.createElement("option", { value: "", disabled: true }, placeholder)) : null,
                options.map((option) => !option.divider ? (React.createElement("option", { value: option.id, disabled: !option.isSelectable, key: option.id }, option.value)) : null))) : null));
    }
    render() {
        const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-activedescendant': ariaActivedescendant, 'aria-controls': ariaControls, mobile, id, disabled, className, displayBlock, } = this.props;
        let content = this._getContent();
        if (!mobile) {
            content = (React.createElement(TextButton, { "aria-haspopup": "menu", "aria-expanded": this.props.isExpanded, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy || id, "aria-activedescendant": ariaActivedescendant, disabled: disabled, "data-hook": DATA_HOOKS.floatingDropdownButton, priority: TextButtonPriority.secondary, className: classes.btn, "aria-controls": ariaControls }, content));
        }
        return (React.createElement("div", { className: st(classes.root, { mobile, disabled }, classnames(classes.overrideStyleParams, className, {
                [classes.displayBlock]: displayBlock,
            })), "data-hook": DATA_HOOKS.base }, content));
    }
}
//# sourceMappingURL=FloatingDropdownBase.js.map